import { createSlice } from '@reduxjs/toolkit';
import { Slices } from 'ducks/slices';
import { NullableNumberInterface } from 'ducks/types/type-helpers';

export type SettingsState = NullableNumberInterface<{
  loading: boolean;
  snackbar: boolean;
  snackbar_variant: 'secondary' | null;
  snackbar_action: null;
  snackbar_label: '';
  snackbar_duration: number;
  sw_registration: ServiceWorkerRegistration | null;
  notification: string;
  status: number | null;
  error: string;
  clear_cache: boolean;
  name: string;
  warning: string | string[];
}>;

const initialState: SettingsState = {
  loading: false,
  snackbar: false,
  snackbar_variant: null,
  snackbar_action: null,
  snackbar_label: '',
  snackbar_duration: null,
  sw_registration: null,
  notification: '',
  status: null,
  error: '',
  clear_cache: false,
  name: '',
  warning: '',
};

const settingsSlice = createSlice({
  name: Slices.SETTINGS,
  initialState,
  reducers: {
    updateSettings: (state, action) => {
      return { ...state, ...action.payload };
    },
    setError: (state, action) => {
      return { ...state, ...action.payload };
    },
    updateSuccess: (state, action) => {
      return {
        ...state,
        snackbar: true,
        snackbar_variant: 'secondary',
        snackbar_action: null,
        snackbar_label: action.payload,
        snackbar_duration: 2500,
      };
    },
    clearSettings: () => {
      return initialState;
    },
  },
});

export const { updateSettings, setError, updateSuccess, clearSettings } = settingsSlice.actions;

export default settingsSlice.reducer;
